import React from "react";
import "../css/PageCss/subcategoriapage.css";

import Header from "../components/Header";
import Footer from "../components/Footer";
import Alcance from "../components/Alcance";
import Manuales from "../components/Manuales";

function SubCategoriaPage() {
  return (
    <div className="SubCategoriaPage">
      <Header />
      <Manuales />
      <Alcance />
      <Footer />
    </div>
  );
}

export default SubCategoriaPage;
